import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import OdwiraCountdown from "./OdwiraCountdown";

export default function PublicLayout() {
  return (
    <div className="min-h-screen parchment-texture">
      <Navbar />
      <OdwiraCountdown />
      <main><Outlet /></main>
      <Footer />
    </div>
  );
}
